import { InputHTMLAttributes } from "react";
import {
  FieldPath,
  FieldValues,
  RegisterOptions,
  useFormContext,
} from "react-hook-form";

type InputProps<TFieldValues extends FieldValues> = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "name"
> & {
  name: FieldPath<TFieldValues>;
  rules?: RegisterOptions<TFieldValues, FieldPath<TFieldValues>>;
};

function Input<TFieldValues extends FieldValues>({
  name,
  rules,
  className = "inputControl",
  ...props
}: InputProps<TFieldValues>) {
  const { register } = useFormContext<TFieldValues>();

  return <input className={className} {...register(name, rules)} {...props} />;
}

export default Input;
